import { useEffect, useState } from "react";
import { Wallet, ArrowDownToLine, ArrowUpFromLine, SlidersHorizontal } from "lucide-react";
import { api, money, fmtDate, label } from "../lib/api";
import { PageHeader, StatCard, Spinner, Avatar } from "../components/bits";

export default function Funds() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/funds").then((r) => setD(r.data)); }, []);
  if (!d) return <Spinner />;
  return (
    <div data-testid="funds-page">
      <PageHeader title="Recorded balance" subtitle="A record of money contributed and paid out across your groups. Nini does not hold these funds." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 stagger mb-8">
        <StatCard label="Recorded balance" value={money(d.recorded_balance)} icon={Wallet} testId="funds-balance" />
        <StatCard label="Money in" value={money(d.money_in)} hint={`Contributions ${money(d.contributions)}`} icon={ArrowDownToLine} testId="funds-in" />
        <StatCard label="Money out" value={money(d.money_out)} hint={`Payouts ${money(d.payouts)}`} icon={ArrowUpFromLine} testId="funds-out" />
        <StatCard label="Adjustments" value={money(d.adjustments)} icon={SlidersHorizontal} testId="funds-adjustments" />
      </div>
      <div className="card overflow-hidden"><div className="p-5 border-b border-nini-border font-semibold text-nini-heading">Transactions</div>
        <div className="divide-y divide-nini-border">{d.transactions.map((t) => (
          <div key={t.id} className="flex items-center gap-4 px-5 py-3.5" data-testid={`tx-${t.id}`}>
            <span className={`h-10 w-10 rounded-xl inline-flex items-center justify-center ${t.direction === "in" ? "bg-nini-mint text-nini-deep" : "bg-nini-surface text-nini-muted"}`}>{t.direction === "in" ? <ArrowDownToLine size={17} /> : <ArrowUpFromLine size={17} />}</span>
            <Avatar src={t.member?.avatar_url} name={t.member?.name} size="h-8 w-8" />
            <div className="flex-1 min-w-0"><div className="text-sm font-medium text-nini-heading truncate">{t.ref_name} <span className="text-nini-muted font-normal">· {t.member?.name}</span></div><div className="text-xs text-nini-muted">{t.group_name} · {label(t.type)} · {fmtDate(t.created_at)}</div></div>
            <span className={`font-semibold tabular-nums ${t.direction === "in" ? "text-nini-deep" : "text-nini-heading"}`}>{t.direction === "in" ? "+" : "−"}{money(t.amount)}</span>
          </div>
        ))}</div>
      </div>
    </div>
  );
}
